import { IconButton, Tooltip, Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VpnKeyRoundedIcon from "@mui/icons-material/VpnKeyRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PropTypes from "prop-types";

export const AgentsManagementActionMenuTable = ({
  onEdit,
  onChangePassword,
  canEdit = false,
  canChangePassword = false,
}) => {

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

      <Tooltip title={canEdit ? "Editar" : "Ver información"} arrow>
        <IconButton
          aria-label={canEdit ? "editar" : "ver información"}
          size="small"
          onClick={onEdit}
          color="primary"
        >
          {canEdit ? <EditIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
        </IconButton>
      </Tooltip>

      <Tooltip title={canChangePassword ? "Restablecer contraseña" : "Sin permisos para restablecer contraseña"} arrow>
        <span>
        <IconButton
          aria-label="restablecer contraseña"
          size="small"
          onClick={onChangePassword}
          color="primary"
          disabled={!canChangePassword}
        >
          <VpnKeyRoundedIcon fontSize="small" />
        </IconButton>
        </span>
      </Tooltip>
      
    </Box>
  )
}

AgentsManagementActionMenuTable.propTypes = {
  onEdit: PropTypes.func,
  onChangePassword: PropTypes.func,
  canEdit: PropTypes.bool,
  canChangePassword: PropTypes.bool,
};
